@let value = soundSignalUrl();
@let icon = iconData();
@let isImgHidden = hideImg();

<div class="relative flex flex-row gap-[0.5rem] items-center shrink-0" [ngClass]="styleClass()">
  @if(!isImgHidden) {
    <img class="size-[1rem]" [src]="icon.src" [alt]="icon.name"/>
  }

  @if (value) {
    <div class="cursor-pointer"
         type="button"
         tabindex="0"
         (keydown.enter)="download($event)"
         (keydown.space)="download($event)"
         (click)="download($event)">
      <svg-icon src="icons/icon-download.svg"
                name="icon-download"
                [ngClass]="{'!opacity-100': showDownloadAlways()}"
                class="size-[1.25rem] flex shrink-0 group-hover:opacity-100 opacity-0 c-default-transition"
                svgClass="!text-(--p-primary-500)"></svg-icon>
    </div>
  }
</div>


